export default __webpack_public_path__ + "static/media/cat.1ca81a48.png";